import { useMutation } from 'react-query';
import { apiDelete } from './apiService';

const deleteFavourite = async (favouriteId: number): Promise<void> => {
  return apiDelete(`favorites/${favouriteId}?fetchPresence=false`);
};

const useDeleteFavouriteMutation = () => {
  return useMutation({
    mutationFn: deleteFavourite,
    mutationKey: ['useDeleteFavouriteMutation']
  });
};

export default useDeleteFavouriteMutation;
